import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, CreditCard, Landmark, ShieldCheck } from 'lucide-react';
export const Offer = () => {
  return <section id="oferta" className="py-24 bg-legal-900 relative" data-id="element-201">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-legal-800 via-legal-900 to-legal-900 pointer-events-none" data-id="element-202"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-203">
        <div className="text-center mb-12" data-id="element-204">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-205">
            MEGAPACK ABOGADO 360° PRO™
          </h2>
          <p className="text-xl text-gold-500 font-medium" data-id="element-206">
            10 Modulos + 5 Bonos Premium
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-lg mx-auto bg-legal-800 rounded-2xl border-2 border-gold-500 shadow-[0_0_40px_rgba(201,162,74,0.15)] overflow-hidden" data-id="element-207">
          <div className="bg-gold-500 py-4 text-center" data-id="element-208">
            <span className="text-legal-900 font-bold uppercase tracking-wider text-sm" data-id="element-209">
              Oferta Especial
            </span>
          </div>

          <div className="p-8 md:p-10" data-id="element-210">
            <div className="mb-6" data-id="element-211">
              <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-212">
                Acceso inmediato y de por vida
              </h3>
              <p className="text-slate-400" data-id="element-213">
                Material digital descargable + 5 bonos
              </p>
            </div>

            <div className="mb-8 pb-8 border-b border-legal-700" data-id="element-214">
              <div className="flex items-end gap-3" data-id="element-215">
                <span className="font-serif text-5xl font-bold text-white leading-none" data-id="element-216">
                  $27.990
                </span>
                <span className="text-slate-400 mb-1" data-id="element-217">pago único</span>
              </div>
              <p className="text-sm text-gold-500 mt-2 font-medium" data-id="element-218">
                Incluye todos los bonos sin costo adicional.
              </p>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-219">
              {['10 Módulos completos', '5 Bonos premium', 'Modelos, IA y Jurisprudencia', 'Acceso inmediato y de por vida', 'Actualizaciones incluidas', 'Garantía de satisfacción de 7 días'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-slate-300" data-id="element-220">
                  <CheckCircle2 className="w-5 h-5 text-gold-500 shrink-0" data-id="element-221" />
                  <span data-id="element-222">{item}</span>
                </li>)}
            </ul>

            <a href="https://megapack-abogado-360-pro.impultienda.ar/checkout" className="block w-full py-5 bg-gold-500 hover:bg-gold-400 text-legal-900 font-bold rounded-xl text-xl text-center transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg mb-6" data-id="element-223">
              QUIERO MI MEGAPACK AHORA
            </a>

            <div className="space-y-4" data-id="element-224">
              <p className="text-center text-sm text-slate-400 font-medium" data-id="element-225">
                Métodos de pago aceptados:
              </p>
              <div className="flex justify-center gap-6 text-slate-300" data-id="element-226">
                <div className="flex flex-col items-center gap-1" data-id="element-227">
                  <CreditCard className="w-6 h-6" data-id="element-228" />
                  <span className="text-xs" data-id="element-229">Tarjetas</span>
                </div>
                <div className="flex flex-col items-center gap-1" data-id="element-230">
                  <div className="w-6 h-6 flex items-center justify-center font-bold text-lg leading-none" data-id="element-231">
                    mp
                  </div>
                  <span className="text-xs" data-id="element-232">Mercado Pago</span>
                </div>
                <div className="flex flex-col items-center gap-1" data-id="element-233">
                  <Landmark className="w-6 h-6" data-id="element-234" />
                  <span className="text-xs" data-id="element-235">Transferencia</span>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-legal-700 flex items-center justify-center gap-2 text-sm text-slate-400" data-id="element-236">
              <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-237" />
              <span data-id="element-238">Pago 100% seguro. Garantía de 7 días.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};